import { getClubs } from "@/http/clubsApi";
import { getClubsQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetClubsQuery = () => {
  return useQuery({
    queryKey: getClubsQueryKey(),
    queryFn: () => getClubs(),
    select: (response) => response.data.data,
  });
};
